// extracted by mini-css-extract-plugin
export default {"main":"Medicaltests_main__3RDij","ltr":"Medicaltests_ltr__24srd","rtl":"Medicaltests_rtl__HGaAe","first":"Medicaltests_first__5HCue","firstPara":"Medicaltests_firstPara__4IKJF"};